const handleDeleteEquipmentModels = {
  text: 'Deseja realmente deletar o tipo de equipamento',
  title: 'DELETAR EQUIPAMENTO'
};

export default handleDeleteEquipmentModels;
